var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageContainer',{staticClass:"pt-10"},[_c('PageHeader',{attrs:{"has-back":"","with-members":""}},[_vm._v(" 進路活動記録 ")]),_c('PathActivityForm',{ref:"form",attrs:{"user-id":_vm.userId},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }